import { render, staticRenderFns } from "./fieldOrderPack.vue?vue&type=template&id=3521684c&scoped=true&"
import script from "./fieldOrderPack.vue?vue&type=script&lang=js&"
export * from "./fieldOrderPack.vue?vue&type=script&lang=js&"
import style0 from "./fieldOrderPack.vue?vue&type=style&index=0&id=3521684c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521684c",
  null
  
)

export default component.exports